// @flow
function sanitizeStagingAndLocalhostUrls(url: string) {
  return url
    .replace('http://localhost:3000/', 'https://noblehire.io/')
    .replace('http://34.89.132.16/', 'https://noblehire.io/');
}

export { sanitizeStagingAndLocalhostUrls };
